module.exports = __webpack_public_path__ + "img/icon_weiguo.7bda5d27.jpg";